<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title pull-left">Cadastro do Avalista</h4>
    <button
      type="button"
      class="close pull-right"
      aria-label="Close"
      (click)="bsModalRef.hide()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form #form="ngForm" class="forms" id="form">
      <div class="row">
        <div class="col-xs-12">
          <app-form-group icon="id-number" label="CPF" labelFor="avalista-cpf">
            <input
              id="avalista-cpf"
              name="avalista-cpf"
              type="text"
              class="form-control"
              placeholder="999.999.999-99"
              [(ngModel)]="avalista.$cpf"
              appShowErrorMessages
              appCpfValidator
              mask-number
              [mask]="'000.000.000-00'"
              minlength="1"
              required
            />
            <div class="text-danger" *ngIf="isCpfInvalido">
              O CPF informado não pode ser igual ao do Cliente ou de outro
              Avalista
            </div>
          </app-form-group>

          <app-form-group
            icon="reference"
            label="Relação com o cliente"
            labelFor="relacao-referencia"
          >
            <app-grau-parentesco
              name="relacao-referencia"
              [(ngModel)]="avalista.grauParentesco"
              [required]="true"
              ngDefaultControl
            ></app-grau-parentesco>
          </app-form-group>

          <app-form-group label="Data de Nascimento" labelFor="data-nascimento">
            <input
              id="data-nascimento"
              name="data-nascimento"
              type="text"
              [(ngModel)]="avalista.$dataNascimento"
              (ngModelChange)="avalista.$dataEmissao = ''"
              mask-number
              [mask]="'00/00/0000'"
              minlength="1"
              class="form-control"
              placeholder="00/00/0000"
              appShowErrorMessages
              appDataValidator
              (valid)="dataNascimentoValida = $event"
              [dateRange]="dataRange"
              required
            />
          </app-form-group>

          <app-form-group
            icon="mobile"
            label="Celular do avalista"
            labelFor="celular-avalista"
          >
            <input
              type="text"
              id="celular-avalista"
              name="celular-avalista"
              class="form-control"
              placeholder="(00) 00000-0000"
              [(ngModel)]="avalista.$celularAvalista"
              [minLength]="11"
              appShowErrorMessages
              appOnlyDigitsLengthValidator
              invalidMessage="Número de celular inválido"
              appTelefone
              appCelularValidator
              required
              (focus)="clearErrorMessage('errorMessage')"
              [ngModelOptions]="{ updateOn: 'blur' }"
            />
            <div class="text-danger" *ngIf="errorMessage">
              {{ errorMessage }}
            </div>
          </app-form-group>

          <app-form-group
            icon="income"
            label="Renda Comprovada"
            labelFor="avalista-renda-comprovada"
          >
            <input
              type="text"
              class="form-control"
              id="avalista-renda-comprovada"
              placeholder="Digite apenas números"
              mask-money
              [prefix]="'R$'"
              name="avalista-renda-comprovada"
              [(ngModel)]="avalista.renda"
              appShowErrorMessages
              [valorMaximo]="this.fichaCadastro?.limiteRenda?.rendaMaxima"
              [valorMinimo]="this.fichaCadastro?.limiteRenda?.rendaMinima"
              required
              [maxLength]="15"
              appOnlyDigitsLengthValidator
              (ngModelChange)="avalista.renda = $event"
              appOnlyMoney
              appRendaValidator
            />
          </app-form-group>

          <app-form-group icon="user" label="Nome" labelFor="nome-avalista">
            <input
              type="text"
              class="form-control"
              id="nome-avalista"
              placeholder="Digite o nome do avalista"
              name="nome-avalista"
              [(ngModel)]="avalista.nome"
              appShowErrorMessages
              appOnlyLetter
              appTextUppercase
              invalidMessage="Nome do avalista inválido"
              required
              minlength="4"
              maxlength="60"
              uppercase
              appMinTwoWords
              [removeSpaceBeginEnd]="true"
              [charOnly]="true"
            />
          </app-form-group>

          <app-form-group icon="email" label="E-mail" labelFor="email-avalista">
            <input
              type="text"
              class="form-control"
              id="email-avalista"
              placeholder="email@exemplo.com.br"
              name="email-avalista"
              [(ngModel)]="avalista.email"
              appEmailValidator
              appShowErrorMessages
              lowercase
              email
              maxlength="100"
              (focus)="clearErrorMessage('errorMessageEmail')"
              genericErrorMessage
              [ngModelOptions]="{ updateOn: 'blur' }"
              required
            />
            <div class="text-danger" *ngIf="isEmailInvalido">
              O E-mail informado não pode ser igual ao do Cliente ou de outro
              Avalista
            </div>
            <div *ngIf="errorMessageEmail" class="text-danger">
              {{ errorMessageEmail }}
            </div>
          </app-form-group>

          <app-form-group
            icon="married"
            label="Estado Civil"
            labelFor="estado-civil"
          >
            <app-estado-civil
              id="estado-civil"
              name="estado-civil"
              [(ngModel)]="avalista.idEstadoCivil"
              [required]="true"
              ngDefaultControl
            ></app-estado-civil>
          </app-form-group>

          <app-form-group
            icon="id-number"
            label="Identificação"
            labelFor="tipo-edentificacao"
          >
            <app-tipo-identificacao
              name="tipo-edentificacao"
              [(ngModel)]="avalista.idTipoDocumento"
              [required]="true"
              ngDefaultControl
            ></app-tipo-identificacao>
          </app-form-group>

          <app-form-group label="Número" labelFor="numero-documento">
            <input
              type="text"
              appOnlyNumber
              [(ngModel)]="avalista.rgIe"
              id="numero-documento"
              name="numero-documento"
              class="form-control"
              appShowErrorMessages
              required
              maxlength="20"
            />
          </app-form-group>

          <app-form-group label="Órgão Expedidor" labelFor="orgao-expedidor">
            <input
              maxlength="20"
              type="text"
              appOnlyLetter
              appTextUppercase
              [(ngModel)]="avalista.rgIeEmissor"
              id="orgao-expedidor"
              name="orgao-expedidor"
              class="form-control"
              appShowErrorMessages
              required
            />
          </app-form-group>

          <app-form-group label="Data de Emissão" labelFor="data-emissao">
            <input
              type="text"
              id="data-emissao"
              name="data-emissao"
              class="form-control"
              placeholder="00/00/0000"
              [(ngModel)]="avalista.$dataEmissao"
              appDataEmissaoValidator
              [dataNascimento]="avalista.$dataNascimento"
              appShowErrorMessages
              required
              mask-number
              [mask]="'00/00/0000'"
            />
            <span class="text-danger" *ngIf="!avalista.$dataNascimento"
              >Informe primeiro a data de nascimento</span
            >
            <span
              class="text-danger"
              *ngIf="avalista.$dataNascimento && !dataNascimentoValida"
              >Informe primeiro uma data de nascimento válida</span
            >
          </app-form-group>

          <app-form-group icon="user" label="Nome da Mãe" labelFor="nome-mae">
            <input
              maxlength="60"
              type="text"
              class="form-control"
              id="nome-mae"
              placeholder="Digite o nome da Mãe"
              name="nome-mae"
              [(ngModel)]="avalista.nomeMae"
              appShowErrorMessages
              invalidMessage="Nome da Mãe inválido"
              required
              minlength="4"
              maxlength="60"
              appOnlyLetter
              appTextUppercase
            />
          </app-form-group>

          <app-form-group icon="user" label="Nome do Pai" labelFor="nome-pai">
            <input
              type="text"
              maxlength="60"
              class="form-control"
              id="nome-pai"
              placeholder="Digite o nome do Pai"
              name="nome-pai"
              [(ngModel)]="avalista.nomePai"
              appShowErrorMessages
              invalidMessage="Nome do Pai inválido"
              [required]="!semRegistroPai"
              minlength="4"
              maxlength="60"
              [disabled]="semRegistroPai"
              appOnlyLetter
              appTextUppercase
            />

            <div class="modal-avalista__switch marginT10 check-mod">
              <app-switch
                id="user-father-name"
                name="ufn"
                (change)="onClickSemRegistroPai()"
              >
              </app-switch>
              <label>
                <span class="radio-label">Sem pai no registro</span>
              </label>
            </div>
          </app-form-group>

          <app-nacionalidade
            name="nacionalidade"
            [(ngModel)]="avalista.$nacionalidade"
            ngDefaultControl
          ></app-nacionalidade>

          <app-endereco
            icon="residencial"
            label="Endereço residencial CEP"
            name="enderecoResidencial"
            [(ngModel)]="avalista.$enderecoResidencial"
            ngDefaultControl
          ></app-endereco>

          <app-dados-profissionais
            #dadosProfissionaisAvalistaComponent
            [(ngModel)]="avalista.$dadoProfissional"
            name="profissao"
            ngModel
            ngDefaultControl
          ></app-dados-profissionais>

          <app-form-group
            icon="patrimony"
            label="Valor total do Patrimônio"
            labelFor="valor-patrimonio"
          >
            <input
              type="text"
              required
              class="form-control"
              id="valor-patrimonio"
              placeholder="Digite apenas números"
              mask-money
              [prefix]="'R$'"
              name="valor-patrimonio"
              [(ngModel)]="avalista.valorPatrimonio"
              (ngModelChange)="avalista.valorPatrimonio = $event"
              appOnlyDigitsLengthValidator
              appShowErrorMessages
              appMoedaValidator
              [valorMinimo]="0.01"
              [maxLength]="15"
              appOnlyMoney
              required
            />
            <small
              >EX: veículo, imóvel, investimentos...
              <br />
              <strong>Importante</strong>: essa é uma informação exigida pelo
              Banco Central.</small
            >
          </app-form-group>

          <app-endereco
            *ngIf="avalista.isEmpresa"
            icon="company"
            label="Endereço Comercial CEP"
            name="enderecoComercial"
            [(ngModel)]="enderecoComercial"
            ngDefaultControl
          ></app-endereco>

          <app-form-group icon="public-person" label="Politicamente Exposto?">
            <small class="subtitle"
              >Exerceu cargo político nos últimos 5 anos ou é parente de
              algum?</small
            >
            <div class="modal-avalista__switch marginT10 check-mod">
              <app-switch
                #avalistaPpe
                id="avalistaPpe"
                (change)="setAvalistaPpe($event)"
              >
              </app-switch>
              <label>
                <span class="radio-label">Sim</span>
              </label>

              <app-switch
                class="modal-avalista__switch_button"
                #avalistaNaoPpe
                id="avalistaNaoPpe"
                (change)="setAvalistaPpe($event)"
              >
              </app-switch>
              <label>
                <span class="radio-label">Não</span>
              </label>
            </div>
          </app-form-group>

          <app-form-group
            label="Endereço para correspondência"
            labelFor="tipo-endereco-correspondencia"
          >
            <app-tipo-endereco
              [showComercial]="avalista.isEmpresa"
              name="tipo-endereco-correspondencia"
              [(ngModel)]="avalista.tipoEnderecoCorresp"
            ></app-tipo-endereco>
          </app-form-group>

          <app-endereco
            *ngIf="avalista.tipoEnderecoCorresp === '7'"
            icon="zip-code"
            label="Endereço para correspondência CEP"
            name="enderecoCorrespondencia"
            [(ngModel)]="enderecoCorrespondencia"
            ngDefaultControl
          ></app-endereco>

          <app-form-group
            icon="reference"
            label="Referência"
            labelFor="nome-referencia"
          >
            <input
              type="text"
              class="form-control"
              id="nome-referencia"
              placeholder="Digite o nome de uma referência do Avalista"
              name="nome-referencia"
              [(ngModel)]="avalista.clienteReferencias[0].nome"
              appShowErrorMessages
              appOnlyLetter
              appTextUppercase
              invalidMessage="Nome da referência do avalista inválido"
              required
              minlength="4"
              maxlength="40"
            />
          </app-form-group>

          <app-form-group
            icon="reference"
            label="Contato da Referência"
            labelFor="telefone-referencia"
          >
            <input
              type="text"
              id="telefone-referencia"
              name="telefone-referencia"
              class="form-control"
              placeholder="(00) 00000-0000"
              appTelefone
              appOnlyDigitsLengthValidator
              appShowErrorMessages
              [minLength]="11"
              [(ngModel)]="avalista.clienteReferencias[0].$telefone"
              required
              genericErrorMessage
              appCelularValidator
              (focus)="clearErrorMessage('errorMessageReference')"
              [ngModelOptions]="{ updateOn: 'blur' }"
            />
            <div *ngIf="errorMessageReference" class="text-danger">
              {{ errorMessageReference }}
            </div>
          </app-form-group>

          <app-veiculo-proprio
            *ngIf="fichaCadastro.isPesados"
            [isPlacaOpcional]="true"
            labelTitle="Informações do Veículo Próprio do Avalista"
            [veiculo]="getVeiculos()"
            (changeForm)="changeFormVeiculoEmSeuNome($event)"
          >
          </app-veiculo-proprio>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-border-orange pull-left"
      (click)="bsModalRef.hide()"
    >
      Fechar
    </button>
    <button
      type="button"
      class="btn btn-full-orange pull-right"
      [disabled]="!form.valid || !isValid"
      (click)="onSubmit()"
    >
      Salvar
      <i class="fa fa-save"></i>
    </button>
  </div>
</div>
